import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { API_BASE_URL } from '../../utils/apiClient';
import './Apple2TS.css';

const Apple2TS = ({ game }) => {
  const [diskImages, setDiskImages] = useState({ s6d1: '', s6d2: '' });
  const [loading, setLoading] = useState(true); // Start with loading state
  const [error, setError] = useState(null);
  
  // Helper function to add debug messages
  const addDebugMessage = (message) => {
    console.log('Apple II Debug:', message);
  };
  
  useEffect(() => {
    if (game?.rom) {
      const processApple2Rom = async () => {
        try {
          setLoading(true);
          addDebugMessage('Starting to process Apple II ROM');
          
          const romPath = game.rom;
          const fullRomUrl = `${API_BASE_URL}${romPath}`;
          addDebugMessage(`ROM path: ${romPath}`);
          
          // Use the ROM file directly (single-file only)
          addDebugMessage('Using ROM file directly');
          setDiskImages({
            s6d1: romPath,
            s6d2: ''
          });
          addDebugMessage(`Set s6d1 to ${romPath}`);
          
          // Verify the file is accessible
          try {
            const testResponse = await fetch(fullRomUrl);
            if (!testResponse.ok) {
              addDebugMessage(`Warning: s6d1 file may not be accessible. Status: ${testResponse.status}`);
            } else {
              addDebugMessage(`s6d1 file is accessible`);
            }
          } catch (err) {
            addDebugMessage(`Error testing s6d1 file access: ${err.message}`);
          }
          
          setLoading(false);
          addDebugMessage('ROM processing completed successfully');
        } catch (err) {
          console.error('Error processing Apple II ROM:', err);
          setError(`Failed to process Apple II ROM: ${err.message}`);
          setLoading(false);
          addDebugMessage(`Error: ${err.message}`);
        }
      };
      
      processApple2Rom();
    } else {
      // No ROM available
      setLoading(false);
      setError("No ROM specified for Apple II TS emulator");
    }
  }, [game]);
  
  if (loading) {
    return (
      <div className="apple2ts-loading">
        <div className="loading-message">Processing disk images...</div>
      </div>
    );
  }
  
  if (error) {
    return (
      <div className="apple2ts-error">
        <div className="error-message">{error}</div>
      </div>
    );
  }
  
  // Ensure diskImages object has default values for safety
  const safeImages = {
    s6d1: diskImages?.s6d1 || '',
    s6d2: diskImages?.s6d2 || ''
  };
  
  // Simplify disk images configuration
  const diskParams = encodeURIComponent(JSON.stringify(safeImages));
  
  return (
    <div className="apple2ts-container">
      <iframe
        src={`/apple2ts/index.html#${diskParams}&backendUrl=${API_BASE_URL}`}
        title={game.titleeng || game.titlechn}
        className="apple2ts-frame emulator-frame"
        allow="autoplay; fullscreen"
        allowFullScreen
        sandbox="allow-same-origin allow-scripts allow-forms allow-modals allow-popups allow-presentation"
      />
    </div>
  );
};

Apple2TS.propTypes = {
  game: PropTypes.object.isRequired
};

export default Apple2TS; 